const trenchingPipelinesAdapter = (pipelines = []) => {
  return pipelines.map((el) => {
    const color = el.color ?? "#9EA1A2";
    const lines = el.lines.map((l) => ({
      id: l.id,
      color,
      startPoint: {
        x: l.startPoint.x,
        y: l.startPoint.y,
      },
      endPoint: {
        x: l.endPoint.x,
        y: l.endPoint.y,
      },
    }));
    return { color, lines };
  });
};

export default trenchingPipelinesAdapter;
